import { OptionsObject, useSnackbar } from "notistack";
import { logout } from "../../api/authentication/logout/LogoutAPI";
import { AlertSuccessProp } from "../../components/SnackbarNoti";

function LogoutPage() {
  const { enqueueSnackbar } = useSnackbar();
  localStorage.removeItem("accessToken");
  logout();
  enqueueSnackbar("Logout successfully", AlertSuccessProp as OptionsObject);
  window.location.href = "/";

  return <></>;
}

export default LogoutPage;
